// AllDays — lista completa
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { TRIP as STATIC_TRIP } from "../data/trip";
import { formatDate } from "../data/helpers";
import { useTripBase } from "../hooks/useTripBase";
import { useTrip } from "../auth/TripContext";

export default function AllDays() {
  const base = useTripBase();
  const { trip: ctxTrip } = useTrip();
  const trip = ctxTrip || {};
  const days = trip.days || [];
  const cityCount = new Set(days.map((d) => d?.city).filter(Boolean)).size;
  return (
    <div className="container-app pt-6 pb-28">
      <Link to={base || "/"} className="inline-flex items-center gap-1 text-sm text-[hsl(var(--muted))] mb-4" data-testid="back-home">
        <ChevronLeft size={16} /> Inicio
      </Link>
      <h1 className="text-3xl font-bold mb-1">Todos los días</h1>
      <p className="text-sm text-[hsl(var(--muted))] mb-6">{days.length} días · {cityCount} ciudades</p>
      <ul className="space-y-2">
        {days.map((d, i) => (
          <li key={d.id || i}>
            <Link
              to={`${base}/dia/${d.id || i}`}
              className="block card-paper p-4 active:scale-[0.98] transition-transform"
              data-testid={`alldays-${d.id || i}`}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-base">{(d.flag || "📍").split(" ")[0]}</span>
                    <span className="text-[11px] uppercase tracking-wider text-[hsl(var(--muted))] font-semibold">
                      {formatDate(d.date)} · {d.dayLabel || d.city || ""}
                    </span>
                  </div>
                  <p className="font-semibold text-[hsl(var(--ink))]">{d.title}</p>
                  <p className="text-xs text-[hsl(var(--muted))] mt-0.5">{d.city}</p>
                </div>
                <ChevronRight size={18} className="text-[hsl(var(--muted))] shrink-0 mt-1" />
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
